/*
  单位选择器
  $emit
    OnValueChanged
 */
<template>
  <div>
    <div v-if="isStudyclassHours">
      <span class="title grey-3">单位: </span>
      <el-select v-model="value" placeholder="请选择开班单位" clearable :class="selectWidth">
        <el-option v-for="item in datas" :key="item.id" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </div>
    <div v-else>
      <span class="title" v-if="showtitle">上级单位:</span>
      <el-select v-model="value" placeholder="请选择上级单位" clearable :class="selectWidth">
        <el-option v-for="item in datas" :key="item.id" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </div>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { optionsApi } from "@/api/module/classunit/classunit";

export default {
  name: "ClassUnitSelect",
  
  mixins: [BaseVue],
  
  props: {
    showtitle: {
      type: Boolean,
      default: true
    },
    isStudyclassHours: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  
  data() {
    return {
      datas: [],
      value: ""
    };
  },
  
  computed: {
    selectWidth() {
      if (this.size == "mini") {
        return "width200";
      } else if (this.size == "small") {
        return "width300";
      } else if (this.size == "medium") {
        return "width400";
      } else if (this.size == "big") {
        return "width600";
      }
      return "width400";
    }
  },
  
  methods: {
    init() {
      this.value = "";
    },
    
    updateVal(id) {
      this.value = id;
    },
    
    callApi(data) {
      optionsApi(data)
        .then((response) => {
          this.datas = response;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  
  created() {
    let data = {
      level: 0,
      status: 0,
    };
    this.callApi(data);
  },
  
  watch: {
    value: {
      handler() {
        // console.log("on value changed", this.value);
        this.$emit("onValueChanged", this.value);
      }
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}

.classunitselect {
  width: 400px;
}
</style>